// extracted by css-extract-rspack-plugin
export default {"avatar":"Users-module__avatar__Bqxpc"};